import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../api/settings";

export function useTenantSettings() {
  return useQuery({
    queryKey: ["tawa", "settings"],
    queryFn: getSettings,
    staleTime: 5 * 60_000,
  });
}
